import { InputGroup } from 'reactstrap'
import React from 'react'
import InputRange from 'react-input-range'
import PropTypes from 'prop-types'
import 'react-input-range/lib/css/index.css'
import clsx from 'clsx'
export default class RangeSlider extends React.Component {
    updateRange = (value) => {
      this.props.updateRange(this.props.valueKey, value)
    }

    render () {
      return (
        <InputGroup className={clsx(this.props.className)}>
          <div className='input-range-wrapper'>
            <InputRange onChange={this.updateRange}
              maxValue={this.props.maxValue}
              minValue={this.props.minValue}
              value={this.props.value}
              formatLabel={this.props.formatLabel}
              step={this.props.step}
            />
          </div>
        </InputGroup>
      )
    }
};

RangeSlider.defaultProps = {
  updateRange: () => { },
  minValue: 0,
  maxValue: 100,
  value: 40,
  formatLabel: (value) => `${value}`,
  step: 1
}

RangeSlider.propTypes = {
  updateRange: PropTypes.func,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  value: PropTypes.number,
  valueKey: PropTypes.string.isRequired
}
